var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('TopNavBar',{on:{"handleItemClick":_vm.handleItemClick}}),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('Footer'),_c('div',{staticClass:"showTheLogin"}),_c('div',{staticStyle:{"position":"fixed","bottom":"320px","right":"50px","z-index":"99"}},[_c('ScrollArrow')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }